import { slideToggle, slideDown, slideUp } from "./slideToggle";

const paymentSelect = document.querySelector<HTMLSelectElement>(".js-payment-select");
const creditValue: string = "クレジットカード決済";
const creditForm = document.querySelector<HTMLElement>(".js-credit-form");
if(paymentSelect) {
  paymentSelect.addEventListener("change", ()=>{
    slidePayment(paymentSelect);
  });
  window.addEventListener("load", ()=>{
    slidePayment(paymentSelect);
  })
}

const slidePayment = (elm: HTMLSelectElement) => {
  if(elm.value === creditValue) {
    slideDown(creditForm, 300, "grid");
  } else {
    slideUp(creditForm);
  }
}
